import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

export const Layout: FC<LayoutProps> = ({ children, header, footer }): ReactNode => {
    return (
        <div className='relative flex min-h-screen flex-col'>
            {header}

            <main id='content' className='flex-1'>
                {children}
            </main>

            {footer}
        </div>
    )
}
